import {
  GET_LIST_REFERRAL_SOURCE,
  GET_LIST_REFERRAL_SOURCE_SUCCESS,
  GET_LIST_REFERRAL_SOURCE_ERROR,
  CLEAR_LIST_REFERRAL_SOURCE,
  CREATE_REFERRAL_SOURCE,
  CREATE_REFERRAL_SOURCE_SUCCESS,
  CREATE_REFERRAL_SOURCE_ERROR,
  CREATE_REFERRAL_SOURCE_CLEAR,
  GET_REFERRAL_SOURCE,
  GET_REFERRAL_SOURCE_SUCCESS,
  GET_REFERRAL_SOURCE_ERROR,
  GET_REFERRAL_SOURCE_CLEAR,
  UPDATE_REFERRAL_SOURCE,
  UPDATE_REFERRAL_SOURCE_SUCCESS,
  UPDATE_REFERRAL_SOURCE_ERROR,
  UPDATE_REFERRAL_SOURCE_CLEAR,
  GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE,
  GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_SUCCESS,
  GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_ERROR,
  GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_CLEAR,
} from "./actionTypes";

export const getListReferralSources = (payload) => {
  return {
    payload,
    type: GET_LIST_REFERRAL_SOURCE,
  };
};
export const getListReferralSourcesSuccess = ({ data, pagination }) => {
  return {
    payload: { data, pagination },
    type: GET_LIST_REFERRAL_SOURCE_SUCCESS,
  };
};
export const getListReferralSourcesError = ({ message }) => {
  return {
    payload: { message },
    type: GET_LIST_REFERRAL_SOURCE_ERROR,
  };
};
export const clearListReferralSources = () => ({
  type: CLEAR_LIST_REFERRAL_SOURCE,
})

export const createReferralSource = (data, history) => {
  return {
    payload: { data, history },
    type: CREATE_REFERRAL_SOURCE,
  };
};

export const createReferralSourceSuccess = ({ data }) => {
  return {
    payload: data,
    type: CREATE_REFERRAL_SOURCE_SUCCESS,
  };
};

export const createReferralSourceError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: CREATE_REFERRAL_SOURCE_ERROR,
  };
};

export const clearReferralSourceCreated = () => {
  return {
    type: CREATE_REFERRAL_SOURCE_CLEAR,
  };
};

export const getReferralSource = (referralSourceId) => {
  return {
    payload: { referralSourceId },
    type: GET_REFERRAL_SOURCE,
  };
};

export const getReferralSourceSuccess = ({ data }) => {
  return {
    payload: data,
    type: GET_REFERRAL_SOURCE_SUCCESS,
  };
};

export const getReferralSourceError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: GET_REFERRAL_SOURCE_ERROR,
  };
};

export const clearReferralSourceFetched = () => {
  return {
    type: GET_REFERRAL_SOURCE_CLEAR,
  };
};

export const updateReferralSource = (data, history) => {
  return {
    payload: { data, history },
    type: UPDATE_REFERRAL_SOURCE,
  };
};

export const updateReferralSourceSuccess = ({ data }) => {
  return {
    payload: data,
    type: UPDATE_REFERRAL_SOURCE_SUCCESS,
  };
};

export const updateReferralSourceError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: UPDATE_REFERRAL_SOURCE_ERROR,
  };
};

export const clearReferralSourceUpdated = () => {
  return {
    type: UPDATE_REFERRAL_SOURCE_CLEAR,
  };
};

// export const removeBundle = (data, history) => {
//   return {
//     payload: { data, history },
//     type: REMOVE_BUNDLE,
//   };
// };

// export const removeBundleSuccess = ({ data }) => {
//   return {
//     payload: data,
//     type: REMOVE_BUNDLE_SUCCESS,
//   };
// };

// export const removeBundleError = ({ message = "Unknown error" }) => {
//   return {
//     payload: { message },
//     type: REMOVE_BUNDLE_ERROR,
//   };
// };

// export const clearBundleRemoved = () => {
//   return {
//     type: REMOVE_BUNDLE_CLEAR,
//   };
// };

// export const changeBundleStatus = (id) => {
//   return {
//     payload: { id },
//     type: CHANGE_BUNDLE_STATUS,
//   };
// };

// export const changeBundleStatusSuccess = ({ data }) => {
//   return {
//     payload: data,
//     type: CHANGE_BUNDLE_STATUS_SUCCESS,
//   };
// };

// export const changeBundleStatusError = ({ message = "Unknown error" }) => {
//   return {
//     payload: { message },
//     type: CHANGE_BUNDLE_STATUS_ERROR,
//   };
// };

// export const changeBundleStatusClear = () => {
//   return {
//     type: CHANGE_BUNDLE_STATUS_CLEAR,
//   };
// };

export const getCoursesForOptionForReferralSource = (pagination) => {
  return {
    payload: pagination,
    type: GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE,
  };
};

export const getCoursesForOptionForReferralSourceSuccess = (data) => {
  return {
    payload: data,
    type: GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_SUCCESS,
  };
};

export const getCoursesForOptionForReferralSourceError = ({ message = "Unknown error" }) => {
  return {
    payload: { message },
    type: GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_ERROR,
  };
};

export const getCoursesForOptionForReferralSourceClear = () => {
  return {
    type: GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_CLEAR,
  };
};